import React, { useState, useEffect, useCallback } from 'react';
import Page from 'src/components/Page';
import { makeStyles } from '@material-ui/styles';
import { LinearProgress } from '@material-ui/core';
import BusinessCard from 'src/components/BusinessCard';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import { Alert } from '@material-ui/lab';
import { useSelector, useDispatch } from 'react-redux';
import {setCard} from '../../actions/index'
import { selectAd } from './adPicker';
import styled from 'styled-components';
const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: '100%',
      overflowX: 'hidden',
    },
    banner: {
      display: 'flex',

      //    marginTop: theme.spacing(4),
    },
  };
});
export default function BusinessCardPage(props) {
  const classes = useStyles();
  const showAds = useSelector((state) => {
    return state?.session?.organization?.showAds;
  });
  const dispatch = useDispatch()
  const {
    match: {
      params: { slug },
    },
  } = props;

  const [cardDetails, setCardDetails] = useState();
  useScripts(cardDetails?.pixels?.filter((p) => !!p.code).map((p) => p.code));
  const [ad, setAd] = useState(null);
  const user = useSelector((state) => {
    return state.session.user;
  });

  const getAd = useCallback(() => {
    firebase
      .firestore()
      .collection('ads')
      .get()
      .then(async (snap) => {
        const ads = snap.docs
          .map((doc) => ({ id: doc.id, ...doc.data() }))
          .filter((item) => !!item.banner && !!item.link);
        const ad = selectAd(ads, user);
        if (ad) {
          const banner = await firebase
            .storage()
            .ref(ad?.banner)
            .getDownloadURL();
          setAd({ ...ad, banner });
        }
      });
  }, [user]);

  useEffect(() => {
    if (showAds) {
      getAd();
    }
  }, [showAds, getAd]);

  const trackClick = useCallback(() => {
    if (ad?.id) {
      firebase
        .firestore()
        .collection('ads')
        .doc(ad.id)
        .collection('events')
        .add({ type: 'click', timestamp: firebase.firestore.Timestamp.now() });
    }
  }, [ad]);

  useEffect(() => {
    firebase
      .firestore()
      .collection('cards')
      .where('slug', '==', slug)
      .get()
      .then((snap) => {
        if (!snap.docs.length) {
          return props.history.replace('/errors/404');
        }

        const [doc] = snap.docs;
        if (['idle', 'disabled'].includes(doc.data()?.status)) {
          return props.history.replace('/errors/404');
        }
        setCardDetails(doc.data());
        dispatch(setCard(doc.data()))
        firebase.firestore().collection('cardViews').add({
          cardId: doc.id,
          timestamp: firebase.firestore.Timestamp.now(),
        });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  if (!cardDetails) {
    return <LinearProgress />;
  }
  return (
    <Page title={slug} className={classes.root}>
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          width: '100%',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {cardDetails?.status === 'expired' && (
          <Alert
            severity="error"
            variant="filled"
            style={{ width: '100%', borderRadius: 0 }}
          >
            כרטיס זה פג תוקף
          </Alert>
        )}
        {/*  <AppBar color="secondary" position="relative">
          <Toolbar
            variant="dense"
            style={{ backgroundColor: cardDetails?.titleColor }}
          >
            Join Us
          </Toolbar>
        </AppBar> */}
        <div
          style={{
            width: '100%',
            height: '100%',
            maxWidth: 640,
            textAlign: 'center',
            background: 'white',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <div
            style={{
              minHeight: '85vh',
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
            }}
          >
            <BusinessCard {...cardDetails} />
          </div>

          {ad && (
            <a
              href={ad?.link}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.banner}
              onClick={trackClick}
            >
              <div>
                <small>פרסום ממומן</small>
                <img
                  src={ad.banner}
                  alt={cardDetails?.title}
                  style={{
                    maxWidth: 640,
                    width: '100vw',

                    height: '30vh',
                    objectFit: 'cover',
                  }}
                />
              </div>
            </a>
          )}
        </div>
        <Footer>
          <small>2021&copy;</small>
          <a href="https://arcatalogue.co.il" className="text">
            <small>ליצירת קטלוג משלכם</small>
            <img
              alt="Logo"
              src="/images/logos/logo-white.png"
              style={{
                width: '4rem',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </a>
        </Footer>
      </div>
    </Page>
  );
}

const Footer = styled.footer`
  padding: 0.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background-color: #121212;
  color: #f4f4f4;
  letter-spacing: 1.1px;

  .text {
    color: #f4f4f4;
    display: flex;
    align-items: center;

    > small {
      margin-inline-end: 0.2rem;
    }
  }
`;

const useScripts = (contents = []) => {
  useEffect(() => {
    const scripts = contents.map((content) => {
      let inlineScript, inlineNoScript;
      const script = document.createElement('script');
      const scriptContentMatches = content.match(
        /(?:<script>)([\s\S]+)(?=<\/script>)/
      );

      const noScript = document.createElement('noscript');
      const noScriptMatches = content.match(
        /(?:<noscript>)[\s\S]+(?=<\/noscript>)/
      );
      if (scriptContentMatches?.length > 0) {
        inlineScript = document.createTextNode(scriptContentMatches[1]);
        script.appendChild(inlineScript);
      }

      if (noScriptMatches?.length > 0) {
        inlineScript = document.createTextNode(scriptContentMatches[1]);
        noScript.appendChild(inlineNoScript);
      }

      document.body.appendChild(script);

      return [script, noScript];
    });

    return () => {
      scripts.flat().forEach((elem) => {
        document.body.removeChild(elem);
      });
    };
  }, [contents]);
};
